export default __webpack_public_path__ + "static/Popup-Shops-During-Fashion-Week-5747a6040be957909fbf9ece11f69358.jpg";